import { E_WebDisplayCellType } from "../../../../../enums/smart-display/cell-type.enum";
import { E_WebDisplaySection } from "../../../../../enums/smart-display/section.enum";
import { ChangesDetection } from "../../../../change-detection";
import {
  C_CellConfig,
} from "../../home/domain/card-config.model";
import {
  I_ConditionsConfigResponse, I_SectionBoxLayoutResponse, E_FlexDirectionResponse, I_RowBoxLayoutResponse,
  I_DetailTabConfigResponse
} from "../api/box-layout-config.response";

export class C_SectionBoxLayoutInfo extends ChangesDetection {

  id?: string;
  type?: E_WebDisplaySection;
  name?: string;
  icon?: string;
  sectionUrl?: string;
  subtitle?: boolean;
  isColumn?: boolean;
  conditions?: I_ConditionsConfigResponse;
  paddingTop?: string;
  paddingBottom?: string;
  paddingLeft?: string;
  paddingRight?: string;
  borderColor?: string;
  borderWidth?: string;
  borderStyle?: string;
  borderRadius?: string;
  hProportion?: number;
  minHeight?: string;
  bgColor?: string;
  cells: C_RowBoxLayoutInfo[] = [];
  direction?: null | 'row' | 'column' | 'row-reverse' | 'column-reverse';
  growPriority?: number;

  constructor(info?: I_SectionBoxLayoutResponse) {
    super();
    if (!info) return;
    if (info.id) this.id = info.id;
    if (info.type) this.type = info.type;
    if (info.name) this.name = info.name;
    if (info.icon) this.icon = info.icon;
    if (info.sectionUrl) this.sectionUrl = info.sectionUrl;
    if (info.subtitle) this.subtitle = info.subtitle;
    if (info.isColumn) this.isColumn = info.isColumn;
    if (info.conditions) this.conditions = info.conditions;
    if (info.paddingTop) this.paddingTop = info.paddingTop;
    if (info.paddingBottom) this.paddingBottom = info.paddingBottom;
    if (info.paddingLeft) this.paddingLeft = info.paddingLeft;
    if (info.paddingRight) this.paddingRight = info.paddingRight;
    if (info.borderColor) this.borderColor = info.borderColor;
    if (info.borderWidth) this.borderWidth = info.borderWidth;
    if (info.borderStyle) this.borderStyle = info.borderStyle;
    if (info.borderRadius) this.borderRadius = info.borderRadius;
    if (info.bgColor) this.bgColor = info.bgColor;
    if (info.growPriority) this.growPriority = info.growPriority;
    if (info.cells) info.cells.forEach(r => this.cells.push(new C_RowBoxLayoutInfo(r)));
    if (info.hasOwnProperty('hProportion')) this.hProportion = info.hProportion!;
    if (info.hasOwnProperty('minHeight')) this.minHeight = info.minHeight!;
    if (info.direction) this.direction = this.evaluateDirection(info.direction);
  }

  evaluateDirection(dir: E_FlexDirectionResponse) {
    switch (dir) {
      case E_FlexDirectionResponse.RowReverse:
        return "row-reverse";
      case E_FlexDirectionResponse.ColumnReverse:
        return "column-reverse";
      case E_FlexDirectionResponse.Row:
        return "row";
      case E_FlexDirectionResponse.Column:
      default:
        return "row";
    }
  }

}
export class C_RowBoxLayoutInfo extends ChangesDetection {

  type: E_WebDisplayCellType = E_WebDisplayCellType.Default;
  growPriority?: number;
  bgColor?: string;
  paddingTop?: string;
  paddingBottom?: string;
  paddingLeft?: string;
  paddingRight?: string;
  cells: C_CellConfig[] = [];
  direction?: E_FlexDirection;
  minWidth?: string;
  minHeight?: string;

  valuePathNested?: string;
  valuePathKey?: string[];

  constructor(info?: I_RowBoxLayoutResponse) {
    super();
    if (!info) return;
    if (info.cells) info?.cells.forEach((cell) => {
      this.cells.push(new C_CellConfig(cell));
    });
    if (info.hasOwnProperty('growPriority')) this.growPriority = info.growPriority;
    if (info.hasOwnProperty('bgColor')) this.bgColor = info.bgColor;
    if (info.hasOwnProperty('paddingTop')) this.paddingTop = info.paddingTop;
    if (info.hasOwnProperty('paddingBottom')) this.paddingBottom = info.paddingBottom;
    if (info.hasOwnProperty('paddingLeft')) this.paddingLeft = info.paddingLeft;
    if (info.hasOwnProperty('paddingRight')) this.paddingRight = info.paddingRight;
    if (info.hasOwnProperty('minWidth')) this.minWidth = info.minWidth;
    if (info.hasOwnProperty('minHeight')) this.minHeight = info.minHeight;
    if (info.hasOwnProperty('valuePathNested')) this.valuePathNested = info.valuePathNested;
    if (info.hasOwnProperty('valuePathKey')) this.valuePathKey = info.valuePathKey;
    if (info.hasOwnProperty('type')) this.type = info.type as E_WebDisplayCellType;
    if (info.hasOwnProperty('direction')) this.direction = this.evaluateDirection(info.direction!);
  }

  evaluateDirection(dir: E_FlexDirectionResponse) {
    switch (dir) {
      case E_FlexDirectionResponse.RowReverse:
        return E_FlexDirection.RowReverse;
      case E_FlexDirectionResponse.ColumnReverse:
        return E_FlexDirection.ColumnReverse;
      case E_FlexDirectionResponse.Row:
        return E_FlexDirection.Row;
      case E_FlexDirectionResponse.Column:
      default:
        return E_FlexDirection.Column;
    }
  }

}

export class C_DetailTabConfig extends ChangesDetection {
  id?: string;
  label?: string;      // "Pase médico", "Pase guardia", etc.
  icon?: string;
  rows: C_SectionBoxLayoutInfo[] = [];    // El array de secciones estructuradas (rows, observations) que ya lee tu motor

  constructor(info?: I_DetailTabConfigResponse) {
    super()
    if (info?.id) { this.id = info.id }
    if (info?.label) { this.label = info.label }
    if (info?.icon) { this.icon = info.icon }
    if (info?.rows) { info.rows.forEach(section => {
      var c = new C_SectionBoxLayoutInfo(section);
      this.rows.push(c);
    }) }
  }

}

export enum E_FlexDirection {
  Column = "column",
  Row = "row",
  RowReverse = "row-reverse",
  ColumnReverse = "column-reverse",
}
